import { useState } from "react";
import { MapPin } from "lucide-react";

export default function BeforeAfterJob({ job, testid }) {
  const [tab, setTab] = useState("before");
  const images = tab === "before" ? job.before : job.after;

  return (
    <div
      data-testid={testid}
      className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            {job.title}
          </h2>
          <p className="mt-1.5 inline-flex items-center gap-1.5 text-sm text-slate-500">
            <MapPin className="h-4 w-4 text-[#FF7F00]" /> {job.location}
          </p>
          <p className="mt-3 max-w-2xl text-slate-600 leading-relaxed">
            {job.summary}
          </p>
        </div>

        {/* Before / After toggle */}
        <div
          role="tablist"
          data-testid={`${testid}-tabs`}
          className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 p-1 self-start md:self-end"
        >
          <button
            type="button"
            role="tab"
            aria-selected={tab === "before"}
            onClick={() => setTab("before")}
            data-testid={`${testid}-tab-before`}
            className={`px-5 h-10 rounded-full text-sm font-bold transition-all ${
              tab === "before"
                ? "bg-[#0F172A] text-white shadow"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            Before
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === "after"}
            onClick={() => setTab("after")}
            data-testid={`${testid}-tab-after`}
            className={`px-5 h-10 rounded-full text-sm font-bold transition-all ${
              tab === "after"
                ? "bg-[#FF7F00] text-white shadow-md shadow-orange-200"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            After
          </button>
        </div>
      </div>

      <div
        key={tab}
        className="mt-6 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4"
        data-testid={`${testid}-grid-${tab}`}
      >
        {images.map((src, i) => (
          <a
            key={src}
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testid}-img-${tab}-${i}`}
            className="group relative block overflow-hidden rounded-2xl border border-slate-200 bg-slate-100 aspect-[4/3] hover:shadow-lg transition-shadow"
          >
            <img
              src={src}
              alt={`${job.title} ${tab} photo ${i + 1}`}
              loading="lazy"
              className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
            />
            <span
              className={`absolute top-2 left-2 inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                tab === "before"
                  ? "bg-slate-900/85 text-white"
                  : "bg-[#FF7F00] text-white"
              }`}
            >
              {tab}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
